import ApplicationController from "./application_controller.js";


export default class extends ApplicationController {
	static values = { apiBaseUrl: String };
	
	connect() {
   		this.insertAuditTrailListTemplate();
   		this.createTable();
  	}
  	
  	disconnect() {}  	
	
	insertAuditTrailListTemplate() {		
    const auditTrailListTemplate = document.getElementById(
      "audit-list-tpl"
    );
    if (auditTrailListTemplate) {
      document
        .getElementById("auditTableContent")
        .replaceWith(auditTrailListTemplate.content.cloneNode(true));
    }
  } 
  
	createTable() {
		$.ajax({
			url: this.apiBaseUrlValue,
			beforeSend: function() {
				$('#audit-loading-text').show(); // Show spinner during request
				const loadingText = document.getElementById("audit-loading-text");
				let dots = 0;
				setInterval(() => {
					dots = (dots + 1) % 20;
					loadingText.textContent = "Loading" + ".".repeat(dots);
				}, 500);

			},
			complete: function() {
				$('#audit-loading-text').hide(); // Hide spinner after data loads
			},
			contentType: "application/json",
			dataType: "json",
			method: "GET",
			success: (response) => {
		    if (response != null) {
		        if (useDataTable) {
		            this.createDataTable(response); 
		        } else {
		            this.createFooTable(response);
		        }
		    } else {
		        console.log("Error! Could not retrieve the data.");
		        $(".fooicon-loader").remove();
		        $(".footable-loader").append("<p>Error retrieving documents</p>");
		    }
			},
		});
	}  
  
	createDataTable(dataIn) {
		if ($jQuery.fn.DataTable.isDataTable("#audit-trail-list")) {
        	return;
		}
		
		const data = dataIn.auditTrailList.map(item => item.auditTrail);
		//$.fn.dataTable.moment("DD/MM/YYYY HH:mm:ss");
		$jQuery("#audit-trail-list").DataTable({
			'deferRender': true,
			'searching': true,
			'stateSave': true,
			stateSaveParams: function(settings, data) {
				data.search.search = "";
			},
			'lengthChange': false,
			'paging': true,
			'pageLength': 50,
			'info': false,
			'processing': true,
			'ordering': true,
			'order': [[0, 'desc']],
			initComplete: function() {
				// $('.dataTables_filter input').val('Filter');
			},
			language: {
				search: '_INPUT_',
				searchPlaceholder: 'Filter'
			},
			columns: [
				{
					data: "type",
					title: "Type",
					responsivePriority: 3,
					render: function(value, type, row) {
						return (
							'<div style="display: inline">' +
							value +
							"</div>"
						);
					}
				},
				{
					data: "date",
					title: "Date",
					//width: "50px !important",
					responsivePriority: 2,
					render: function(value, type, row) {
						return (
							'<div style="display: inline">' +
							(value ? moment.utc(value).local().format("DD/MM/YYYY HH:mm") : "") +
							"</div>"
						);
					}
				},
				{
					data: "submittedBy",
					title: "Submitted by",
					responsivePriority: 1,
					render: (data, options, rowData) => {
						return data;
					},
				},
				{
					data: "action",
					title: "Actions",
					responsivePriority: 4,
					render: (value, options, rowData) => {
				        return (
				          `<div data-controller="panel"
				     		data-panel-title-value="${value.actionName}"
				     		data-panel-document-url-value="${value.urlString}">
				     		<div role="navigation" aria-label="Actions for transaction ${value.actionName}">
				  				<span data-action="click->panel#open"><a href="#">Details</a></span>
				  			</div>
							</div>`
				        );
				},
				},
			],
			data: data,
		});
	}  
 }